import React from 'react';
import { connect } from 'react-redux';
import { string } from 'prop-types';
import Helmet from 'react-helmet';

import { ZH_HK as DEFAULT_URL_LOCALE } from '@snapask/common-components/dist/constants/urlLocale';

import config from '@blueberry/config';
import { defaultLanguage } from '@blueberry/constants/languages';
import { getLanguage, getLocaleCode } from '@blueberry/redux/locale';

const { SITE_ENDPOINT, FB_APP_ID } = config;

const seoAssetPath = path => `${SITE_ENDPOINT}/static/seo/${path}`;

const seoImages = {
  openGraph: 'Home_SEO.jpg',
  twitter: 'Home_SEO.jpg',
  google: 'Home_SEO.jpg',
};

const getMetaTags = ({
  title,
  description,
  seoImage,
  path,
  contentType,
  published,
  updated,
  category,
  tags,
  urlLocale,
  robots,
}) => {
  const metaTags = [
    /* eslint-disable object-property-newline */
    { charset: 'utf-8' },
    { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
    { itemprop: 'name', content: title },
    { itemprop: 'description', content: description },
    {
      itemprop: 'image',
      content: seoImage || seoAssetPath(seoImages.openGraph),
    },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, minimum-scale=1.0',
    },
    { name: 'robots', content: robots },
    { name: 'url', content: `${SITE_ENDPOINT}/${urlLocale}/${path}` },
    { name: 'description', content: description },
    { name: 'twitter:card', content: 'summary_large_image' },

    { property: 'og:title', content: `${title}` },
    { property: 'og:type', content: contentType },
    { property: 'og:url', content: `${SITE_ENDPOINT}/${urlLocale}/${path}` },
    {
      property: 'og:image',
      content: seoImage || seoAssetPath(seoImages.openGraph),
    },
    { property: 'og:description', content: description },
    { property: 'fb:app_id', content: FB_APP_ID },
  ];

  if (published)
    metaTags.push({ name: 'article:published_time', content: published });
  if (updated)
    metaTags.push({ name: 'article:modified_time', content: updated });
  if (category) metaTags.push({ name: 'article:section', content: category });
  if (tags) metaTags.push({ name: 'article:tag', content: tags });

  return metaTags;
};

const mapStateToProps = state => ({
  urlLocale: getLocaleCode(state),
  lang: getLanguage(state),
});

/**
 * @TODO
 *  - add schema
 *  - add i18n translation
 */
const SEOHead = ({
  lang,
  schema,
  title,
  seoImage,
  description,
  path,
  contentType,
  published,
  updated,
  category,
  tags,
  urlLocale,
  robots,
}) => (
  <Helmet
    htmlAttributes={{
      lang,
      itemscope: undefined,
      itemtype: `http://schema.org/${schema}`,
    }}
    title={title}
    link={[
      {
        rel: 'canonical',
        href: `${SITE_ENDPOINT}/${urlLocale}/${path}`,
        hreflang: lang,
      },
    ]}
    link={[
      {
        rel: 'alternate',
        href: `${SITE_ENDPOINT}/${urlLocale}/${path}`,
        hreflang: lang,
      },
    ]}
    meta={getMetaTags({
      title,
      description,
      seoImage,
      contentType,
      path,
      published,
      updated,
      category,
      tags,
      urlLocale,
      robots,
    })}
  />
);

SEOHead.propTypes = {
  category: string,
  contentType: string,
  description: string,
  lang: string,
  path: string,
  published: string,
  robots: string,
  schema: string,
  seoImage: string,
  tags: string,
  title: string,
  updated: string,
  urlLocale: string,
};

SEOHead.defaultProps = {
  contentType: 'website',
  title: 'Snapask Academy｜Study tips and lifehacks',
  description:
    'Snapask Academy offers useful study tips and interesting lifehacks through articles and videos for secondary school students. We will enrich your learning journey and provide you a personalised learning experience.', // eslint-disable-line max-len
  path: '',
  category: '',
  published: '',
  updated: '',
  tags: '',
  seoImage: '',
  schema: 'Service',
  lang: defaultLanguage,
  urlLocale: DEFAULT_URL_LOCALE,
  robots: 'index, follow',
};

export default connect(mapStateToProps, null)(SEOHead);



// WEBPACK FOOTER //
// ./app/components/SEOHead/SEOHead.jsx